import { useEffect, useState } from "react";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import useApi from "../../../hooks/useApi";
import Formulario from "../../../Componentes/Utils/Formulario";
import FormComp from "../../../Componentes/FormComp";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";

const ModalEditItem = ({ isPedido, id, fetchData, fecharModal }) => {

    const api = useApi();

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [itemData, setItemData] = useState(null);

    const fetchItemData = async () => {
        try {
            const url = isPedido ? `/Painel/API/ControleMedicao/GetPedido/index.php?id=${id}` : `/Painel/API/ControleMedicao/GetAditivo/index.php?id=${id}`;
            const { data } = await api.get(url);
            setItemData(data);

            console.log(data);
        } catch (error) {
            console.error("Erro ao buscar dados do item:", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchItemData();
    }, [])

    const handleChange = (e) => {

        const { name, value } = e.target;

        setItemData(prev => ({
            ...prev,
            [name]: value.toUpperCase()
        }));

    }

    const handleSubmit = async (e) => {

        e.preventDefault();

        setSaving(true);

        try{

            const formData = new FormData();

            formData.append("id", id);
            formData.append("num_contrato", itemData.num_contrato);
            formData.append("art", itemData.art);
            formData.append("cno", itemData.cno);

            await api.post("/Painel/API/ControleMedicao/EditPedido/", formData);

            fetchData();
            fecharModal();

        }catch( e ){

            console.error( e );

        }finally{

            setSaving(false);

        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header close={fecharModal} >
                    {
                        loading ? (
                            <SmallLoading />
                        ) : (
                            <Formulario onSubmit={ handleSubmit } >
                                <FormComp
                                    title="Nº DO CONTRATO"
                                    type="text"
                                    name="num_contrato"
                                    valor={itemData?.num_contrato || ""}
                                    changeFunc={( e ) => handleChange( e )}
                                />
                                <FormComp
                                    title="ART"
                                    type="text"
                                    name="art"
                                    valor={itemData?.art || ""}
                                    changeFunc={( e ) => handleChange( e )}
                                />
                                <FormComp
                                    title="CNO"
                                    type="text"
                                    name="cno"
                                    valor={itemData?.cno || ""}
                                    changeFunc={( e ) => handleChange( e )}
                                />
                                <FormComp
                                    type="submit"
                                    valor={saving ? "SALVANDO..." : "SALVAR"}
                                    disabled={saving}
                                />
                            </Formulario>
                        )
                    }
                </Modal>
            </Overlay>
        </>
    )

}

export default ModalEditItem;